// extracted by mini-css-extract-plugin
export default {"textarea":"JNP_3_","label":"y6FJ6c"};